<template>
    <c-audit-overview
        v-if         = "data"
        :data        = "data"
        :height      = "height-420"
        :type        = "type"
        :device-type = "deviceType"
        :country     = "inspection.country"
    />
</template>

<script>

import Disposition    from "@/modules/dis/service/Disposition";
import PAreaMixin     from "@/modules/dis/components/inspection/common/mixins/PAreaMixin";
import CAuditOverview from "@/modules/audit/components/CAuditOverview.vue";
import AuditType, { ELEVATOR, ESCALATOR } from "@/modules/audit/service/AuditType";

export default {
    name: "CDispositionAudit",

    components: {
        CAuditOverview,
    },

    mixins: [
        PAreaMixin
    ],

    props: {
        type: {

        }
    },

    data: () =>({
        catalogueIndex: 0,
        deviceType    : ELEVATOR,
    }),

    computed: {
        hasData () {
            return this.data.entries && this.data.entries.length > 0;
        },

        elevatorEnums () {
            return this.$store.getters.audit;
        },

        escalatorEnums () {
            return this.$store.getters.auditEscalator;
        },
    },

    mounted() {
        this.load();
    },

    watch: {
        inspection () {
            this.load();
        },

        type () {
            this.load();
        },

        escalatorEnums () {
            this.load();
        }
    },

    methods: {
        /** The catalogue entries of the area (GBU/ESG) in a catalogue set. */
        areaCatalogue (enums) {
            return enums && enums.catalogue ? enums.catalogue.filter(c => c.category.area === this.type) : null;
        },

        load () {
            if (!this.inspection) {
                return;
            }

            let audit;
            switch (this.type) {
                case Disposition.inspection.areas.GBU:
                    audit = this.inspection.audit;
                    break;
                case Disposition.inspection.areas.ESG:
                    audit = this.inspection.esg;
                    break;
                default:
                    return;
            }

            if (!audit) {
                this.data = null;
                return;
            }

            // GBU type of the inspection (HCIT-917); ESG exists for elevators only. The escalator catalogue is loaded
            // again if it failed at the start.
            this.deviceType = this.type === Disposition.inspection.areas.ESG ? ELEVATOR : AuditType.dispositionDeviceType(
                this.inspection.deviceType, audit, this.areaCatalogue(this.escalatorEnums));
            if (this.deviceType === ESCALATOR && !this.escalatorEnums) {
                this.$store.dispatch('initAuditEscalatorEnums');
            }

            const own = this.deviceType === ESCALATOR ? this.escalatorEnums : this.elevatorEnums;
            const other = this.deviceType === ESCALATOR ? this.elevatorEnums : this.escalatorEnums;
            const ratings = (own || this.elevatorEnums).ratings;

            // entries are looked up in the set of the type first, then in the other one, so none is dropped
            const entries = AuditType.dispositionEntries(
                audit, [ this.areaCatalogue(own), this.areaCatalogue(other) ], ratings);

            const facilities = [];
            audit.facilities.selected.forEach (id => {
                facilities.push({ id: id })
            });

            const hazards = [];
            audit.hazards.selected.forEach (id => {
                hazards.push({ id: id })
            });

            this.data = {
                deviceType         : this.deviceType,
                entries            : entries,
                facilities         : facilities,
                hazards            : hazards,
                customerMeasure    : audit.facilities["measuresCustomer"],
                manufacturerMeasure: audit.facilities["measuresManufacturer"],
                hazardMeasure      : audit.hazards.measures,
            }
        },
    }
}
</script>

<style scoped>

</style>